module.exports = __webpack_public_path__ + "static/KinderGradBG-571bd30a86ccd4423623ce817c807503.png";